import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { ActionButtonComponent } from "@components/action-button/action-button.component";
import { PageComponent } from "@components/page/page.component";
import { orderBy } from "lodash";
import { BusyService } from "~app/common/components/busy/busy.service";
import { ModalSettings } from "~app/common/components/modal/modal-models";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ToastService } from "~app/common/components/toast/toast.service";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { MeddelandeInfotavlaDTO } from "~app/common/models/meddelandeInfotavla/MeddelandeInfotavlaDTO";
import { AuthenticationService } from "~app/common/services/authentication/authentication.service";
import { CommonTexts } from "~app/common/texts/common.texts";
import { DateUtils as dateUtils } from "~app/common/utils/date-utils";
import { LaggtillSystemaktivitetComponent } from "~app/features/administration/systemaktivitet/laggtill-systemaktivitet/laggtill-systemaktivitet.component";
import { SystemaktivitetService } from "~app/features/administration/systemaktivitet/systemaktivitet.service";
import { SystemaktivitetTexts } from "~app/features/administration/systemaktivitet/systemaktivitet.texts";
import { SystemaktivitetContainerComponent } from "./systemaktivitet-container/systemaktivitet-container.component";

@Component({
    selector: "rask-systemaktivitet",
    templateUrl: "./systemaktivitet.component.html",
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        SystemaktivitetContainerComponent,
        ActionButtonComponent
    ]
})
export class SystemaktivitetComponent implements OnInit {
    texts = SystemaktivitetTexts.texts;
    commonTexts = CommonTexts.texts;
    systemaktivitetlista: MeddelandeInfotavlaDTO[];
    systemaktivtet: MeddelandeInfotavlaDTO;

    private readonly authenticationService = inject(AuthenticationService);
    private readonly busyService = inject(BusyService);
    private readonly raskModalService = inject(RaskModalService);
    private readonly systemaktivitetService = inject(SystemaktivitetService);
    private readonly toastService = inject(ToastService);

    constructor() {
        this.systemaktivitetService.allMeddelandeInfotavlor$.subscribe(x => this.onMeddelandetavlorChanged(x));
    }

    canEdit() {
        return this.authenticationService.canEdit();
    }

    create = (): void => {
        const meddelande = new MeddelandeInfotavlaDTO();
        meddelande.datumFran = dateUtils.shortDateString(new Date());
        meddelande.datumTill = dateUtils.shortDateString(new Date());
        this.openDialogFor(meddelande, this.texts.addSystemaktivitet);
    };

    delete(systemaktivitet: MeddelandeInfotavlaDTO) {
        this.raskModalService.confirm(new ModalSettings(this.texts.deleteSystemaktivitetDialogHead, this.texts.deleteSystemaktivitetDialogPromt))
            .subscribe((response) => {
                if (response === ConfirmDialogResponse.save) {
                    const worker = this.busyService.addWork(this.systemaktivitetService.deleteSystemaktivitet(systemaktivitet));
                    worker.subscribe(result => {
                        this.toastService.add(this.texts.deleteSystemaktivitetConfirmed);
                    });
                }
            });
    }

    edit = (systemaktivitet: MeddelandeInfotavlaDTO): void => {
        this.openDialogFor(systemaktivitet, this.texts.editSystemaktivitet);
    };

    ngOnInit() {
        this.systemaktivitetService.refreshMeddelandeInfotavlor();
    }

    onMeddelandetavlorChanged(result: MeddelandeInfotavlaDTO[]) {
        this.systemaktivitetlista = orderBy(result, g => g.datumTill, "desc");
    }

    private openDialogFor(meddelande: MeddelandeInfotavlaDTO, header: string) {
        this.raskModalService.open(header, LaggtillSystemaktivitetComponent, "lg", true, meddelande);
    }
}
